export const trafficLightsMixin = {
  methods: {
    mapIntStatusLevelToString(statusInt) {
      return statusInt == 0 ? 'good' : statusInt == 1 ? 'critical' : 'severe' //eslint-disable-line
    },
    semaphorLightObjectArray(statusString) {
      return [
        { isRed: statusString == 'severe' }, //eslint-disable-line
        { isOrange: statusString == 'critical' }, //eslint-disable-line
        { isGreen: statusString == 'good' } //eslint-disable-line
      ]
    }
  }
}
